import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SaveAlertComponent } from './save-alert.component';
import { ObservableInput } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SaveAlertService {
  constructor(private snackBar: MatSnackBar) {}

  showSaveAlert(message: string, action: () => ObservableInput<any> ) {
    return this.snackBar.openFromComponent(SaveAlertComponent, {
      data: { message, action }, // Pass the logic here
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: 'save-alert-panel'
    });
  }
}
